(function () {
  if (window.UpbeRestockNotify) return;

  const selectors = {
    block: '[data-restock-notify]',
    variantId: '[data-restock-variant-id]',
    variantTitle: '[data-restock-variant-title]',
    variantOptions: '[data-restock-variant-options]',
  };

  function normalizeVariantTitle(variant, block) {
    if (!variant) return '';
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return block?.dataset.productTitle || '';
  }

  function normalizeVariantOptions(variant) {
    if (!variant?.options || !variant.options.length) return '';
    return variant.options.filter(Boolean).join(' / ');
  }

  function updateBlock(block, variant, productInfo) {
    if (!block) return;

    const isVisible = Boolean(variant && variant.available === false);
    block.hidden = !isVisible;

    const variantIdField = block.querySelector(selectors.variantId);
    const variantTitleField = block.querySelector(selectors.variantTitle);
    const variantOptionsField = block.querySelector(selectors.variantOptions);

    if (variantIdField) variantIdField.value = variant?.id || '';
    if (variantTitleField) variantTitleField.value = normalizeVariantTitle(variant, block);
    if (variantOptionsField) variantOptionsField.value = normalizeVariantOptions(variant);
  }

  function getSelectedVariant(productInfo) {
    const selectedVariantNode = productInfo?.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantNode?.textContent) return null;

    try {
      return JSON.parse(selectedVariantNode.textContent);
    } catch (error) {
      console.error('Failed to parse selected variant data for restock notify', error);
      return null;
    }
  }

  function initProductInfo(productInfo) {
    if (!productInfo) return;
    const block = productInfo.querySelector(selectors.block);
    if (!block) return;
    updateBlock(block, getSelectedVariant(productInfo), productInfo);
  }

  function initAll() {
    document.querySelectorAll('product-info').forEach(initProductInfo);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', (event) => {
    initProductInfo(event.target.closest('product-info') || event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const variant = event?.data?.variant || null;
      if (!sectionId) return;

      const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (!productInfo) return;

      updateBlock(productInfo.querySelector(selectors.block), variant, productInfo);
    });
  }

  window.UpbeRestockNotify = {
    initAll,
    initProductInfo,
  };
})();
